import gql from 'graphql-tag';

export const productVariantHolderFragments = gql`
  fragment productVariantHolderFragments on ProductVariantHolder {
    id
    name
    description
    attributeName
    variants {
      id
      name
      product {
        id
        number
        name
      }
    }
  }
`;
